export const setTitle = (title) => ({ type: 'SET_TITLE', payload: title });